import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";
import AdminGate from "@/pages/AdminGate";
import StaffPage from "@/pages/StaffPage";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/admin" element={<AdminGate />} />
                    <Route path="/admin/majitel" element={<AdminPage />} />
                    <Route path="/admin/brigadnice" element={<StaffPage />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
        </div>
    );
}

export default App;
